import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=21dc837e&scoped=true"
import script from "./NodeConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./NodeConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NodeConfig.vue?vue&type=style&index=0&id=21dc837e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc837e",
  null
  
)

export default component.exports